import React from "react";

import { Tag } from "components/Common/clearsense-ui/components";

export const combineDataFromSourceSystems = (data, accessor, cdeFilters) => {
  const EXCLUDED_CDES = [
    "Practitioner First Name",
    "Practitioner Last Name",
    "Business Entity Name",
  ];

  return Object.entries(
    Object.assign(
      ...Object.values(
        Object.assign(...JSON.parse(data.result?.[0]?.[accessor]))
      ).flat()
    )
  )
    ?.filter(
      ([cdeName, obj]) => obj.visibility && !EXCLUDED_CDES.includes(cdeName)
    )
    ?.filter(([cde, obj]) => {
      if (cdeFilters.length) {
        if (cde.includes("Hierarchy")) {
          return obj.cde_values
            .flat()
            ?.map(child => Object.entries(child)[0])
            .some(([cde, obj]) => {
              if (cdeFilters.length) {
                if (cde.includes("Hierarchy")) {
                  return obj.cde_values
                    .flat()
                    ?.map(child => Object.entries(child)[0])
                    .some(([cde]) => cdeFilters.includes(cde));
                }

                return cdeFilters.includes(cde);
              }

              return true;
            });
        }

        return cdeFilters.includes(cde);
      }

      return true;
    })
    ?.sort(([, obj1], [, obj2]) => obj1?.["sort_order"] - obj2?.["sort_order"])
    ?.map(([cde, obj], idx) => ({
      key: idx,
      cde: obj.display_name.replace(" Hierarchy", ""),
      [accessor]: obj?.cde_values,
      ...(cde.includes("Hierarchy") && {
        children: obj.cde_values
          .map((hierarchyChild, idx) =>
            hierarchyChild
              ?.map(child => Object.entries(child)[0])
              ?.filter(([cde, obj]) => {
                if (cdeFilters.length) {
                  if (cde.includes("Hierarchy")) {
                    return obj.cde_values
                      .flat()
                      ?.map(child => Object.entries(child)[0])
                      .some(([cde]) => cdeFilters.includes(cde));
                  }

                  return cdeFilters.includes(cde);
                }

                return true;
              })
              ?.sort(
                ([, obj1], [, obj2]) =>
                  obj1?.["sort_order"] - obj2?.["sort_order"]
              )
              ?.map(([cde2, obj2]) => ({
                key: `${obj.display_name}${obj2.display_name}${idx}`,
                cde: obj2.display_name.replace(" Hierarchy", ""),
                [accessor]: obj2?.cde_values,
                ...(cde2.includes("Hierarchy") && {
                  children: obj2.cde_values
                    .map((hierarchyChild, idx) =>
                      hierarchyChild
                        ?.map(child => Object.entries(child)[0])
                        ?.filter(([cde]) =>
                          cdeFilters.length ? cdeFilters.includes(cde) : true
                        )
                        ?.sort(
                          ([, obj1], [, obj2]) =>
                            obj1?.["sort_order"] - obj2?.["sort_order"]
                        )
                        ?.map(([, obj3]) => ({
                          key: `${obj2.display_name}${obj3.display_name}${idx}`,
                          cde: obj3.display_name.replace(" Hierarchy", ""),
                          [accessor]: obj3?.cde_values,
                        }))
                    )
                    .flat(),
                }),
              }))
          )
          .flat(),
      }),
    }));
};

export const formatDataForSurvivorshipDomainDetailsTable = (
  data,
  cdeFilters,
  sourceSystems
) => {
  const sourceSystemsData = sourceSystems.map(sourceSystem =>
    combineDataFromSourceSystems(data, sourceSystem, cdeFilters)
  );

  sourceSystemsData?.[0]?.map((_, idx) => {
    if (sourceSystemsData?.[0]?.[idx]?.children) {
      sourceSystemsData?.[0]?.[idx]?.children?.map((_, idx2) => {
        if (sourceSystemsData?.[0]?.[idx]?.children?.[idx2]?.children) {
          sourceSystemsData?.[0]?.[idx]?.children?.[idx2]?.children?.map(
            (_, idx3) => {
              const temp = sourceSystemsData.map(
                sourceSystemData =>
                  sourceSystemData?.[idx]?.children?.[idx2]?.children?.[idx3]
              );
              temp.unshift(temp.pop());
              Object.assign(...temp);
            }
          );
        }
      });
    }
  });

  sourceSystemsData?.[0]?.map((_, idx) => {
    if (sourceSystemsData?.[0]?.[idx]?.children) {
      sourceSystemsData?.[0]?.[idx]?.children?.map((_, idx2) => {
        const temp = sourceSystemsData.map(
          sourceSystemData => sourceSystemData?.[idx]?.children?.[idx2]
        );
        Object.assign(...temp);
      });
    }
  });

  sourceSystemsData?.[0]?.map((_, idx) => {
    const temp = sourceSystemsData.map(
      sourceSystemData => sourceSystemData?.[idx]
    );
    temp.unshift(temp.pop());
    Object.assign(...temp);
  });

  return sourceSystemsData?.[0];
};

export const valueTag = values =>
  values?.map((item, idx) => (
    <div key={idx}>
      {item?.highlight ? (
        <Tag
          size="large"
          color="#fff2d7"
          label={item?.value}
          className="m-1 border-[#f57c00] border text-[#f57c00]"
        />
      ) : (
        item?.value && (
          <Tag
            size="large"
            color="#ffffff"
            label={item?.value}
            className="m-1 border"
          />
        )
      )}
    </div>
  ));
